/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { User } from '@jira/platform__rest-user/src/user.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';

export const currentUserResource: RouteResource<User | null> = createResource<User | null>({
	type: 'CURRENT_USER',
	getKey: (_routerContext, { tenantContext }) => {
		return tenantContext?.atlassianAccountId ?? 'current-user-key';
	},
	getData: async (_routerContext, { tenantContext: { atlassianAccountId } }) => {
		if (!atlassianAccountId) {
			return null;
		}
		return performGetRequest(`/rest/api/2/user?accountId=${atlassianAccountId}`);
	},
});

export function useCurrentUserResource(): UseResourceHookResponse<User | null> {
	return useResource(currentUserResource);
}

export function useCurrentUserResourceIfEligible(
	isEligibleToCall: boolean,
): UseResourceHookResponse<User | null> | null {
	const result = useResource(currentUserResource);
	return isEligibleToCall ? result : null;
}
